/* @flow */
import * as React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import Text from 'components/Text';
import Tooltip from 'components/Tooltip';
import TooltipTrigger from 'components/TooltipTrigger';

type Props = {
  count: number,
};

const RemainingCharactersCount = ({ count }: Props) => {
  const hasPaidLongCharacterLimit = CurrentUser.getUser().hasPaidLongCharacterLimit();
  const announcementCharactersLimit = CurrentUser.getUser().getAnnouncementCharactersLimit();

  if (hasPaidLongCharacterLimit && count > 200) {
    const tooltip = (
      <Tooltip>
        Your administrator upgraded to a Remind plan. You can now send announcements up to{' '}
        {announcementCharactersLimit} characters long.
      </Tooltip>
    );

    return (
      <TooltipTrigger tooltip={tooltip}>
        <Glyph name="chat-smile" size="large" color="koala" />
      </TooltipTrigger>
    );
  }

  const textColor = count < 0 ? 'lava' : 'eclipse';

  return (
    <Text color={textColor} size="xxsmall" data-test-selector="character_count">
      {count}
    </Text>
  );
};

export default RemainingCharactersCount;
